module.exports = __webpack_public_path__ + "operace-nosu_9_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_9_after.jpg
// module id = 1143
// module chunks = 0